"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptTestDtoToJSON = exports.OptTestDtoFromJSONTyped = exports.OptTestDtoFromJSON = exports.instanceOfOptTestDto = void 0;
var runtime_1 = require("../runtime");
var HelperBaseConceptDto_1 = require("./HelperBaseConceptDto");
var ReferenceDto_1 = require("./ReferenceDto");
var SearchGroupDto_1 = require("./SearchGroupDto");
/**
 * Check if a given object implements the OptTestDto interface.
 */
function instanceOfOptTestDto(value) {
    var isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfOptTestDto = instanceOfOptTestDto;
function OptTestDtoFromJSON(json) {
    return OptTestDtoFromJSONTyped(json, false);
}
exports.OptTestDtoFromJSON = OptTestDtoFromJSON;
function OptTestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'ontology': !(0, runtime_1.exists)(json, 'ontology') ? undefined : json['ontology'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'mapperVersion': !(0, runtime_1.exists)(json, 'mapperVersion') ? undefined : json['mapperVersion'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : json['tags'],
        'aggregationType': !(0, runtime_1.exists)(json, 'aggregationType') ? undefined : json['aggregationType'],
        'searchGroups': !(0, runtime_1.exists)(json, 'searchGroups') ? undefined : (json['searchGroups'].map(SearchGroupDto_1.SearchGroupDtoFromJSON)),
        'genesTargeted': !(0, runtime_1.exists)(json, 'genesTargeted') ? undefined : json['genesTargeted'],
        'reasonsForTesting': !(0, runtime_1.exists)(json, 'reasonsForTesting') ? undefined : json['reasonsForTesting'],
        'disorderInformation': !(0, runtime_1.exists)(json, 'disorderInformation') ? undefined : json['disorderInformation'],
        'alias': !(0, runtime_1.exists)(json, 'alias') ? undefined : json['alias'],
        'assayNotes': !(0, runtime_1.exists)(json, 'assayNotes') ? undefined : json['assayNotes'],
        'clinicalDescription': !(0, runtime_1.exists)(json, 'clinicalDescription') ? undefined : json['clinicalDescription'],
        'inheritanceParagraph': !(0, runtime_1.exists)(json, 'inheritanceParagraph') ? undefined : json['inheritanceParagraph'],
        'assayNoteParagraph': !(0, runtime_1.exists)(json, 'assayNoteParagraph') ? undefined : json['assayNoteParagraph'],
        'conceptType': !(0, runtime_1.exists)(json, 'conceptType') ? undefined : json['conceptType'],
        'geneFunction': !(0, runtime_1.exists)(json, 'geneFunction') ? undefined : json['geneFunction'],
        'geneAssociatedDisorders': !(0, runtime_1.exists)(json, 'geneAssociatedDisorders') ? undefined : json['geneAssociatedDisorders'],
        'metaDescription': !(0, runtime_1.exists)(json, 'metaDescription') ? undefined : json['metaDescription'],
        'disordersTested': !(0, runtime_1.exists)(json, 'disordersTested') ? undefined : json['disordersTested'],
        'alternativeTests': !(0, runtime_1.exists)(json, 'alternativeTests') ? undefined : json['alternativeTests'],
        'clinicNotes': !(0, runtime_1.exists)(json, 'clinicNotes') ? undefined : json['clinicNotes'],
        'productType': !(0, runtime_1.exists)(json, 'productType') ? undefined : json['productType'],
        'preferredSpecimen': !(0, runtime_1.exists)(json, 'preferredSpecimen') ? undefined : json['preferredSpecimen'],
        'alternateSpecimens': !(0, runtime_1.exists)(json, 'alternateSpecimens') ? undefined : json['alternateSpecimens'],
        'billing': !(0, runtime_1.exists)(json, 'billing') ? undefined : json['billing'],
        'references': !(0, runtime_1.exists)(json, 'references') ? undefined : (json['references'].map(ReferenceDto_1.ReferenceDtoFromJSON)),
        'geneTests': !(0, runtime_1.exists)(json, 'geneTests') ? undefined : (json['geneTests'].map(HelperBaseConceptDto_1.HelperBaseConceptDtoFromJSON)),
        'totalGenesCount': !(0, runtime_1.exists)(json, 'totalGenesCount') ? undefined : json['totalGenesCount'],
        'isCustomizable': !(0, runtime_1.exists)(json, 'isCustomizable') ? undefined : json['isCustomizable'],
        'isRemovable': !(0, runtime_1.exists)(json, 'isRemovable') ? undefined : json['isRemovable'],
    };
}
exports.OptTestDtoFromJSONTyped = OptTestDtoFromJSONTyped;
function OptTestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'name': value.name,
        'ontology': value.ontology,
        'description': value.description,
        'mapperVersion': value.mapperVersion,
        'tags': value.tags,
        'aggregationType': value.aggregationType,
        'searchGroups': value.searchGroups === undefined ? undefined : (value.searchGroups.map(SearchGroupDto_1.SearchGroupDtoToJSON)),
        'genesTargeted': value.genesTargeted,
        'reasonsForTesting': value.reasonsForTesting,
        'disorderInformation': value.disorderInformation,
        'alias': value.alias,
        'assayNotes': value.assayNotes,
        'clinicalDescription': value.clinicalDescription,
        'inheritanceParagraph': value.inheritanceParagraph,
        'assayNoteParagraph': value.assayNoteParagraph,
        'conceptType': value.conceptType,
        'geneFunction': value.geneFunction,
        'geneAssociatedDisorders': value.geneAssociatedDisorders,
        'metaDescription': value.metaDescription,
        'disordersTested': value.disordersTested,
        'alternativeTests': value.alternativeTests,
        'clinicNotes': value.clinicNotes,
        'productType': value.productType,
        'preferredSpecimen': value.preferredSpecimen,
        'alternateSpecimens': value.alternateSpecimens,
        'billing': value.billing,
        'references': value.references === undefined ? undefined : (value.references.map(ReferenceDto_1.ReferenceDtoToJSON)),
        'geneTests': value.geneTests === undefined ? undefined : (value.geneTests.map(HelperBaseConceptDto_1.HelperBaseConceptDtoToJSON)),
        'totalGenesCount': value.totalGenesCount,
        'isCustomizable': value.isCustomizable,
        'isRemovable': value.isRemovable,
    };
}
exports.OptTestDtoToJSON = OptTestDtoToJSON;
